(() => {
  const selector = '[data-collection-pattern-toggle]';
  const pendingPatternSelector = '.card__pattern-image[data-pattern-src], .card__pattern-image[data-pattern-product]';
  const patternRequests = new Map();
  let active = false;

  const loadDiscoveryPattern = (image, src) => {
    const card = image.closest('.collection-discovery__card');
    if (!card) return;
    image.addEventListener('load', () => {
      card.classList.add('collection-discovery__card--pattern-ready');
    }, { once: true });
    image.addEventListener('error', () => {
      card.classList.remove('collection-discovery__card--pattern-ready');
    }, { once: true });
    const imageUrl = new URL(src, window.location.origin);
    image.srcset = [360, 533, 720, 940, 1066, 1280, 1600].map((width) => {
      const candidate = new URL(imageUrl.href);
      candidate.searchParams.set('width', String(width));
      return `${candidate.href} ${width}w`;
    }).join(', ');
    image.sizes = '(min-width: 1760px) 550px, (min-width: 990px) 31.25vw, 62.5vw';
    image.src = src;
  };

  const hydratePatternImages = (scope = document) => {
    scope.querySelectorAll('.card__pattern-image[data-pattern-src]').forEach((image) => {
      const src = image.dataset.patternSrc;
      const srcset = image.dataset.patternSrcset;

      if (image.closest('.collection-discovery__card')) {
        if (src) loadDiscoveryPattern(image, src);
      } else {
        if (srcset) image.srcset = srcset;
        if (src) image.src = src;
      }

      image.removeAttribute('data-pattern-src');
      image.removeAttribute('data-pattern-srcset');
    });
    scope.querySelectorAll('.card__pattern-image[data-pattern-product]').forEach((image) => {
      if (image.dataset.patternLoading) return;
      const handle = image.dataset.patternProduct;
      image.dataset.patternLoading = 'true';
      if (!patternRequests.has(handle)) {
        const root = window.Shopify?.routes?.root || '/';
        const request = fetch(`${root}products/${encodeURIComponent(handle)}?view=pattern-image`, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('pattern_unavailable');
            return response.json();
          }).catch((error) => {
            patternRequests.delete(handle);
            throw error;
          });
        patternRequests.set(handle, request);
      }
      patternRequests.get(handle).then((data) => {
        if (!image.isConnected) return;
        if (data.image) loadDiscoveryPattern(image, data.image);
        image.removeAttribute('data-pattern-product');
      }).catch(() => {
        // Keep the mockup if artwork is unavailable; allow a later retry.
      }).finally(() => { delete image.dataset.patternLoading; });
    });
  };

  const syncControls = () => {
    document.documentElement.classList.toggle('collection-pattern-active', active);
    document.querySelectorAll(selector).forEach((control) => {
      control.setAttribute('aria-checked', String(active));
    });
  };

  const setActive = (nextActive) => {
    active = nextActive;
    if (active) hydratePatternImages();
    syncControls();
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest(selector);
    if (!control) return;

    event.preventDefault();
    setActive(!active);
  });

  document.addEventListener('shopify:section:load', () => {
    if (active) hydratePatternImages();
    syncControls();
  });

  const gridObserver = new MutationObserver((mutations) => {
    if (!active) return;

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(pendingPatternSelector)) {
          hydratePatternImages(node.parentElement || document);
        } else if (node.querySelector(pendingPatternSelector)) {
          hydratePatternImages(node);
        }
      });
    });
  });

  const startObserving = () => {
    const collectionSection = document.getElementById('ProductGridContainer')?.parentElement || document.body;
    gridObserver.observe(collectionSection, { childList: true, subtree: true });
  };

  syncControls();
  startObserving();
})();
